CCL.hideCurtesyHoldNotification = {
  autoload: [
    ['hideCurtesyHoldNotification', $('.c-alert-banner-courtesy-hold-notification').length > 0]
  ],

  hideCurtesyHoldNotification() {
    $('.close-notification').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        const targetElement = $(event.target).parents('.c-alert-banner-courtesy-hold-notification');
        $(targetElement).removeClass('show');
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-alert-banner-courtesy-hold-notification/alert-banner-courtesy-hold-notification.js